import React from 'react';
import { Navigate } from 'react-router';
import { NavLink } from 'react-router-dom';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';

export class Home extends Base {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            loading: true
        }
    }
    componentDidMount() {
        this.httpPost("api/v1/home")
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    renderForm() {
        return <div className="container">
            <div className="page-header">
                <h4 className="iransans txt-gray">
                    <strong>سلام {this.state.data.global.user.fname} {this.state.data.global.user.lname}</strong> آخرین ورود شما {this.state.data.global.user.lastLoginDate} با آی پی <b>{this.state.data.global.user.lastLoginIp}</b>
                </h4>
            </div>
            <div className="row">
                <div className="col-xs-12 col-sm-12 col-md-8">
                    <table className="table table-bordered table-hover">
                        <caption className="text-right iransans">کسب و کارهای شما</caption>
                        <thead>
                            <tr className="active" style={{ "font-size": "9pt", "font-weight": "bold" }}>
                                <td>عنوان کسب و کار</td>
                                <td>تاریخ ایجاد</td>
                                <td>آخرین ورود</td>
                                <td>تعداد اعضا</td>
                                <td style={{ "width": "70px", "text-align": "center" }} >دسترسی</td>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.data.records.map(p =>
                                this.isBlank(p.parentId) && [
                                    <tr>
                                        <td>
                                            <a onClick={e => this.changeOrganization(p.id)} className="hand" style={{ "background-color": "transparent", "border": "none", "color": "#337ab7", "font-weight": "700" }}>{p.name}</a>
                                        </td>
                                        <td className="text-center">{p.createDate}</td>
                                        <td className="text-center">{p.lastLogin}</td>
                                        <td className="text-center">{p.userCount}</td>
                                        <td className="text-center"><a>{p.relationString}</a></td>
                                    </tr>
                                    ,
                                    this.state.data.records.map(c =>
                                        c.parentId == p.id && <tr>
                                            <td>
                                                <a onClick={e => this.changeOrganization(p.id)} className="hand" style={{ "background-color": "transparent", "border": "none", "color": "#337ab7", "font-weight": "700" }}>{c.name}</a>
                                            </td>
                                            <td className="text-center">{c.createDate}</td>
                                            <td className="text-center"></td>
                                            <td className="text-center"><a className="text-info hand"></a></td>
                                            <td className="text-center"></td>
                                            <td className="text-center"><a></a></td>
                                        </tr>)
                                ])}
                        </tbody>
                    </table>
                </div>
                <div className="col-xs-12 col-sm-12 col-md-4">
                    <div className="panel panel-default center-block" style={{ "max-width": "300px", "font-size": "10pt", "margin-top": "43px", "text-align": "center" }} >
                        <div className="panel-body txt-gray">
                            <strong>آیا کسب و کار دیگری را مدیریت میکنید</strong>
                        </div>
                        <div className="panel-footer">
                            <NavLink to="/business/new" className="btn btn-success center-block iransans"><strong>افزودن یک کسب و کار</strong></NavLink>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                this.renderForm(),
                <Footer />
            ];

        return contents;
    }
}